export enum PredefinedAddonCategory {

    CALL = "Call",

    CHAT = "Chat",

    CODE = "Code",

    MEDIA = "Media",

    DRAWING = "Drawing",

    SCHEDULER = "Scheduler",

    NOTES = "Notes",

    DOCUMENTS = "Documents",
}
